import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../assets/styles/studentlogin.css";

function StudentLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "https://shuttle-craft-student-transport.onrender.com/api/auth/student-login",
        {
          email: email.trim().toLowerCase(),
          password: password.trim(),
        }
      );

      //sucess
      localStorage.setItem("studentId", res.data.studentId);
      navigate("/student-dashboard");


    } catch (err) {
      // Case 1: Wrong email/password
      if (err.response && err.response.status === 401) {
        alert("❌ Invalid Student Login");
    
      // Case 2: Server sleeping / network issue
      } else {
        alert("⏳ Server waking up... wait 10 sec & try again");
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Student Login</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Student Email"
            value={email}
            autoCapitalize="none"
            autoCorrect="off"
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default StudentLogin;
